<div class="plant-key-wrapper">
  <mat-accordion>
    <mat-expansion-panel
      [expanded]="true"
      (click)="click()"
      class="plant-key-container"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <ng-container *ngIf="iconPlantKey">
            <i
              class="fa fa-sort-desc arrow-expansion-panel-customize desc"
              aria-hidden="true"
            ></i>
          </ng-container>
          <ng-container *ngIf="!iconPlantKey">
            <i
              class="fa fa-sort-asc arrow-expansion-panel-customize asc"
              aria-hidden="true"
            ></i>
          </ng-container>
          <span class="title-header">Plant Key Operation Data</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div
        fxLayout="row wrap"
        fxLayout.xs="column"
        class="items-row"
        fxLayoutAlign="center flex-start"
      >
        <div
          class="items-container"
          fxFlex="25%;"
          fxFlex.xs="70%"
          fxLayout="column wrap"
          fxLayout.xs="column"
          fxLayoutAlign="center flex-start"
        >
          <div fxFlex="100%;" fxFlex.xs="70%" class="title-info">
            Plant Start Time
          </div>
          <div fxFlex="100%;" fxFlex.xs="70%" class="value-info">
            {{ plantStartTime | date: 'yyyy-MM-dd hh:mm:ss' }}
          </div>
        </div>
        <div
          class="items-container"
          fxFlex="25%;"
          fxFlex.xs="70%"
          fxLayout="column wrap"
          fxLayout.xs="column"
          fxLayoutAlign="center flex-start"
        >
          <div fxFlex="100%;" fxFlex.xs="70%" class="title-info">
            Operating Hours
          </div>
          <div fxFlex="100%;" fxFlex.xs="70%" class="value-info">
            {{ operatingHours }} Hrs
          </div>
        </div>
        <div
          class="items-container"
          fxFlex="25%;"
          fxFlex.xs="70%"
          fxLayout="column wrap"
          fxLayout.xs="column"
          fxLayoutAlign="center flex-start"
        >
          <div fxFlex="100%;" fxFlex.xs="70%" class="title-info">
            Plant Stop Time
          </div>
          <div fxFlex="100%;" fxFlex.xs="70%" class="value-info">
            {{ plantStopTime | date: 'yyyy-MM-dd HH:mm:ss' }}
          </div>
        </div>
        <div
          class="items-container"
          fxFlex="25%;"
          fxFlex.xs="70%"
          fxLayout="column wrap"
          fxLayout.xs="column"
          fxLayoutAlign="center flex-start"
        >
          <div fxFlex="100%;" fxFlex.xs="70%" class="title-info">
            System Health
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="Bosch-Ic-information"
              style="width: max-content"
              matTooltip="System Health - RED (NOT OK) - VeryCritical Alert(s) has Started and NOT ENDED &#013;ORANGE (NOT OK) - Critical Alert(s) has Started and NOT ENDED &#013;GREEN (OK) - 
                No Alerts configured (or) Informative Alert(s) has Started and NOT ENDED (or) All Alerts has ENDED &#013;For more info, click on Notification Tab"
            ></mat-icon>
          </div>
          <div fxFlex="100%;" fxFlex.xs="70%" class="value-info">
            <span [ngClass]="sysHealthColor"></span> {{ sensorHealthMsg }}
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
